import styles from './Indicator.module.css';

type TProps = {
  numberUnread: number;
};

export const Indicator = ({ numberUnread }: TProps) => {
  return numberUnread > 0 ? (
    <div data-testid="whats-new-indicator" className={styles.indicator} />
  ) : null;
};
